export function factorySetStateAction(action) {
  function actionSetState(payload) {
    return { type: action, payload }
  }
  return actionSetState
}

export function factoryReducer(initialState, ActionTypes) {
  function genericReducer(state = initialState, action) {
    switch (action.type) {
      case ActionTypes.SET_STATE:
        return { ...state, ...action.payload }
      default:
        return state
    }
  }
  return genericReducer
}
